// let parent = document.querySelector('.theiaStickySidebarr').parentElement;

// while (parent) {
//     const hasOverflow = getComputedStyle(parent).overflow;
//     if (hasOverflow !== 'visible') {
//         console.log(hasOverflow, parent);
//     }
//     parent = parent.parentElement;
// }
jQuery_T4NT(document).ready(function ($) {
  $(document).click(function (e) {
    if ($(e.target).is('.modal-open')) {
        document.getElementById('bundle_popup').classList.remove('popup-show');
     document.body.classList.remove('modal-open');
    }

});
});


// product images
jQuery_T4NT(document).ready(function ($) {
 var carousel = document.querySelector('.pr_carousel');
var flkty = new Flickity(carousel, {
  initialIndex: 0,
  accessibility: true,
  draggable:1,
  autoPlay: false,
  watchCSS: true,
  wrapAround: true,
  cellAlign: "center",
  autoPlay: false,
  prevNextButtons:false,
  adaptiveHeight: false,
  imagesLoaded: true, 
  lazyLoad: 0,
  dragThreshold : 6,
  pageDots: true
  });
flkty.on( 'change', function( index ) {
  // console.log('Flickity change ' + index );
});
});



jQuery_T4NT(document).ready(function ($) {
  $(".js-sl-item").click(function () {
    // console.log($(this).attr("itemNo"));
    var ind = $(this).attr("itemNo");
    setTimeout(function () {
      $(".pswp__thumbnails .pswp_thumb_item:nth-child(" + ind + ")").trigger(
        "click"
      );
    }, 100);
  });

  // any code js

  //   product image show more
  $(".show-more").click(function () {
    var loadMoreText = $(this).attr("data--loadMoretext");
    var loadLessText = $(this).attr("data--loadLesstext");
    $(this).toggleClass("active");
    if ($(this).hasClass("active")) {
      $(this).html(loadLessText);
      $(".list-wise-images .p-item.hide").addClass("active");
    } else {
      $(this).html(loadMoreText);
      $(".list-wise-images .p-item.hide").removeClass("active");
    }
  });

  //   social share
  $(".social-head button").click(function () {
    $(this).parent(".social-head").siblings(".social-share").toggle();
  });

//filter
  setTimeout(function () {
    $(document).on("click", ".all-headings li", function (i, v) {
      $(this).siblings().removeClass("active");
      $(this).toggleClass("active");
      var open_trgt = $(this).children("h5").attr("date-target");
      $(open_trgt).siblings().removeClass("active");
      $(open_trgt).toggleClass("active");
    });
  }, 3000);

  $(".sortby_pick").click(function () {
    $(".widget").removeClass("active");
    $(".all-headings li").removeClass("active");
  });
});
//   sizechart

jQuery_T4NT(document).ready(function ($) {
  $("ul.tabs").each(function () {
    var active,
      content,
      links = $(this).find("a");
    active = links.first().addClass("active");
    content = $(active.attr("href"));
    links.not(":first").each(function () {
      $($(this).attr("href")).hide();
    });
    $(this)
      .find("a")
      .click(function (e) {
        active.removeClass("active");
        content.hide();
        active = $(this);
        content = $($(this).attr("href"));
        active.addClass("active");
        content.show();
        return false;
      });
  });
});

//manu back
jQuery_T4NT(document).ready(function ($) {
  $(document).on("click", ".menu-item.back-menu-item", function (i, v) {
    $(this).parents("li.menu-item-has-children").removeClass("nt_opended");
  });
});

// fetch('https://pro.ip-api.com/json/?fields=countryCode&key=SXs3XvNnKoUQP2y')
// .then(response => response.json())
// .then(data => console.log(data));

// Toggle active states and flickity
// var items = document.getElementById("items");
// items && all.addEventListener("click", function () {
//   this.classList.toggle("active");
//   items.classList.toggle("items-columns");

//   if (!is_touch_device()) {
//     if (isFlickity) flickity.destroy();
//     else flickity = new Flickity(items, options);

//     isFlickity = !isFlickity;
//   }
// });





//  var carousel = document.querySelector(".sp-pr-gallery.pr_carousel");
// var flkty = new Flickity(carousel, {
// watchCSS: true,
// cellAlign: "center",
// wrapAround: true,
// autoPlay: false,
// prevNextButtons:false,
// adaptiveHeight: false,
// imagesLoaded: true, 
// lazyLoad: 0,
// pageDots: true
// });

// flkty.on("change", function() {
//   console.log("Flickity active slide: " + flkty.selectedIndex);

//   flkty.cells.forEach(function(cell, i) {
//     if (cell.element == flkty.selectedElement) {
//       // play video if active slide contains one
//       // use <video playsinline ..> in your html to assure it works on ios devices
//       var video = cell.element.querySelector("video");
//       if (video) {
//         console.log("playing video " + i);
//         video.play();
//       }
//       return;
//     }

//     // pause all other videos
//     var video = cell.element.querySelector("video");
//     if (video) {
//       console.log("pausing video " + i);
//       video.pause();
//     }
//   });
// });



